interface TabBadgeProps {
  count: number
}

/**
 * Small numeric badge positioned above a tab icon.
 * aria-hidden because the count is communicated via the parent's aria-label.
 */
export function TabBadge({ count }: TabBadgeProps) {
  return (
    <span
      aria-hidden="true"
      className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-accent text-white text-[10px] font-bold leading-none px-1"
    >
      {count}
    </span>
  )
}
